import { Box, useMediaQuery, Card, CardContent, CardMedia, Button, Typography } from '@mui/material';
import theme from '../../../theme.js';
import CustomHighlightedBox from '../../Box/CustomHighlightedBox.jsx';

const categoryImages = require.context(
  "../../../assets/images/catagories",
  false,
  /\.(png|jpe?g)$/i
);

const CatagoriesForm = ({ setSelectedCatagory, categoriesList, history }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const resolvedCategories = categoriesList || [];
  const visibleCategories =
    resolvedCategories.length > 4
      ? resolvedCategories.slice(4)
      : resolvedCategories;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "20px",
      }}
    >
      <Box
        sx={{
          display: "grid",
          width: isMobile ? "95%" : "1150px",
          gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
          gap: isMobile ? "16px" : "24px",
          marginTop: "20px",
          justifyItems: "center",
        }}
      >
        {visibleCategories.map((category, index) => (
          <Card
            key={index}
            sx={{
              width: isMobile ? 150 : 260,
              backgroundColor: "transparent",
              boxShadow: "none",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: isMobile ? "210px" : "310px",
                width: "100%",
                padding: 0,
                backgroundColor: "#ffffff",
                borderRadius: "15px",
                overflow: "hidden",
                "&:hover .hoverOverlay": {
                  opacity: 1,
                },
                "&:hover .mainImage": {
                  opacity: 0.5, // Reduce opacity to make both visible
                },
              }}
            >
              <CardMedia
                component="img"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  backgroundColor: "#ffffff",
                  padding: isMobile ? "8px" : "10px",
                  boxSizing: "border-box",
                  transform: "scale(1)",
                  transformOrigin: "center",
                }}
                image={(() => {
                  try {
                    return categoryImages(`./${category}.png`);
                  } catch (error) {
                    return "";
                  }
                })()}
                className="mainImage"
              />

              <Box
                className="hoverOverlay"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                  background: "rgba(255, 255, 255, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  zIndex: 1,
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    zIndex: 2,
                    backgroundColor: theme.button.backgroundColor.main,
                    color: theme.button.textColor.main,
                    textTransform: "capitalize",
                    fontWeight: "700",
                    "&:hover": {
                      backgroundColor: "#ddd",
                    },
                    marginTop: "20px",
                    width: isMobile ? "80px" : "120px",
                    fontSize: isMobile ? "8px" : "15px",
                  }}
                  onClick={() => {
                    setSelectedCatagory(category);
                  }}
                >
                  View All
                </Button>
              </Box>
            </Box>

            <CardContent>
              <CustomHighlightedBox
                title={category}
                sx={{
                  padding: "15px",
                  fontSize: isMobile ? "8px" : "15px",
                }}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default CatagoriesForm;
